import { useMutation, useQueryClient } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  contractParkingSpotsKey,
  type IncludeFilter,
} from './useAPIGetContractParkingSpots'
import {
  ReservationBody,
  reservationBodySchema,
  ReservationResponse,
  reservationResponseSchema,
} from '../../../common/validations/parkingSpotSchemas'

import { post } from 'api/apiClient'

export const useAPICreateContractParkingSpotReservation = (
  contractUuid?: string
) => {
  const qc = useQueryClient()

  return useMutation({
    mutationKey: contractUuid
      ? ([
          'contracts',
          contractUuid,
          'parking-spots',
          'create-reservation',
        ] as const)
      : undefined,
    mutationFn: async (rawBody: ReservationBody) => {
      if (!contractUuid) {
        throw new Error('Missing contractUuid for reservation')
      }

      const body = reservationBodySchema.parse(rawBody)

      const url =
        API_ENDPOINTS.CONTRACT_PARKING_SPOT_RESERVATIONS?.replace(
          ':contractUuid',
          contractUuid
        ) ?? `/contracts/${contractUuid}/parking-spots/reservations`

      return post<ReservationResponse>(url, body, reservationResponseSchema)
    },
    throwOnError: false,
    retry: false,
    onSuccess: async (..._args) => {
      const invalidate = (inc: IncludeFilter) =>
        qc.invalidateQueries({
          queryKey: contractParkingSpotsKey(contractUuid!, inc),
        })

      await Promise.all([invalidate('all'), invalidate('own')])
    },
  })
}
